module.exports = __webpack_public_path__ + "static/media/offerCard.0c30e323.png";